export default "__VITE_ASSET__Cg4j0zHN__"